import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  NEW_PRICING_PROFILE_MASSIVE_UPDATE_PATH,
  PRICING_PROFILE_MASSIVE_UPDATE_PATH,
} from '../../../../config/paths';
import { PRICING_PROFILE_MASSIVE_UPDATE_COLUMNS } from '../../../../config/columns';
import {
  clearPricingProfileMassiveUpdates,
  getPricingProfileMassiveUpdates,
} from '../../../../actions';

export const PricingProfileMassiveUpdates = ({
  breadcrumbs,
  pricingProfileMassiveUpdate,
  loading,
  dispatchGetPricingProfileMassiveUpdates,
  dispatchClearPricingProfileMassiveUpdates,
}) => {
  useLayoutEffect(() => () => dispatchClearPricingProfileMassiveUpdates(), []);

  const data = pricingProfileMassiveUpdate.get('content') || [];
  const pages = pricingProfileMassiveUpdate.get('totalPages') || null;
  const defaultPageSize =
    pricingProfileMassiveUpdate.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Actualizaciones Masivas de Perfiles de Precio"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_PRICING_PROFILE_MASSIVE_UPDATE_PATH}
      tableStructure={{
        columns: PRICING_PROFILE_MASSIVE_UPDATE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetPricingProfileMassiveUpdates,
        modelPath: PRICING_PROFILE_MASSIVE_UPDATE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetPricingProfileMassiveUpdates: getPricingProfileMassiveUpdates,
  dispatchClearPricingProfileMassiveUpdates: clearPricingProfileMassiveUpdates,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Actualizaciones Masivas de Perfiles de Precio',
      href: PRICING_PROFILE_MASSIVE_UPDATE_PATH,
    },
  ],
  pricingProfileMassiveUpdate: SalesUnit.PricingProfileMassiveUpdate.getIn([
    'all',
    'content',
  ]),
  loading: SalesUnit.PricingProfileMassiveUpdate.getIn(['all', 'loading']),
});

PricingProfileMassiveUpdates.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  pricingProfileMassiveUpdate: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetPricingProfileMassiveUpdates: PropTypes.func.isRequired,
  dispatchClearPricingProfileMassiveUpdates: PropTypes.func.isRequired,
};

PricingProfileMassiveUpdates.defaultProps = {
  pricingProfileMassiveUpdate: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PricingProfileMassiveUpdates);
